import clsx from 'clsx';
import { InputLabelGhost } from '@//components/InputLabel';
import { RangeSlider, type RangeSliderProps, type SingleRange } from '@//components/RangeSlider';
import { Textfield, type TextfieldProps } from '../Textfield';
import styles from './RangeSliderTextfield.module.scss';

interface RangeSliderTextfieldProps {
  id: string;
  label: string;
  rangeSlider: RangeSliderProps<SingleRange>;
  textfield: TextfieldProps;
  variant?: 'default' | 'compact';
}

export const RangeSliderTextfield = ({
  id,
  label,
  rangeSlider,
  textfield,
  variant = 'default',
}: RangeSliderTextfieldProps) => (
  <fieldset
    className={clsx(styles.group, {
      [styles.groupCompact]: variant === 'compact',
    })}
    aria-describedby={id}
  >
    <legend className="sr-only" id={id}>
      {label}
    </legend>
    <Textfield {...textfield} />
    <div className={styles.rangeSlider}>
      {variant === 'compact' && <InputLabelGhost className={styles.ghostLabel} />}
      <div className={styles.inputAlignment}>
        <RangeSlider {...rangeSlider} />
      </div>
    </div>
  </fieldset>
);
